import { Question } from "./question";

export interface AnswerFieldQuestion extends Question {
  answer?: string;
}
